export default "__VITE_ASSET__DYPNf31C__"